import LoggedOut from "./LoggedOut";

export default LoggedOut;
